import script from "./LandingAdvantages.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingAdvantages.vue?vue&type=script&setup=true&lang=js"

import "./LandingAdvantages.vue?vue&type=style&index=0&id=b5fd856c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5fd856c"]])

export default __exports__